import React from "react";
import styled from "styled-components";
const StyledFlexContainer = styled.div`
  display: flex;
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  gap: ${(props) => props.spacing};
  flex-direction: ${(props) => props.direction};
`;

const Flex = ({
  alignItems,
  justifyContent,
  direction,
  spacing,
  children,
  ...props
}) => {
  return (
    <StyledFlexContainer
      alignItems={alignItems}
      justifyContent={justifyContent}
      direction={direction}
      spacing={spacing}
      {...props}
    >
      {children}
    </StyledFlexContainer>
  );
};

export default Flex;

Flex.defaultProps = {
  alignItems: "center",
  justifyContent: "space-between",
  direction: "column",
  spacing: "2rem",
};
